import React from 'react';
import { Dropdown } from '@grubhubprod/gh-cookbook-react';
import { SearchFilters } from 'src/components/DataTable/types/DataTable';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';

export type DataTableSingleSelectFilterOption = {
  value: string;
  text: string;
};

export type DataTableSingleSelectFilterProps<TFilters> = {
  filterKey: keyof TFilters;
  options: DataTableSingleSelectFilterOption[];
  placeholder: string;
  clearLabel?: string;
};

export function DataTableSingleSelectFilter<TFilters = SearchFilters>({
  filterKey,
  options,
  placeholder,
  clearLabel,
}: DataTableSingleSelectFilterProps<TFilters>): JSX.Element {
  const { tableState, setFilters } = useDataTableContext<unknown, TFilters>();
  const filterValue = tableState[filterKey];
  const selectedValue = typeof filterValue === 'string' ? filterValue : '';
  const dropdownOptions = [
    ...(clearLabel ? [{ value: '', text: clearLabel }] : []),
    ...options,
  ];

  return (
    <Dropdown
      aria-label={placeholder}
      multiple={false}
      block
      placeholder={placeholder}
      value={selectedValue}
      options={dropdownOptions}
      onSelect={(value): void =>
        setFilters({ [filterKey]: value || undefined } as Partial<TFilters>)
      }
    />
  );
}
